import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n";

const content = {
  privacy: {
    it: {
      title: "Privacy Policy",
      updated: "Ultimo aggiornamento: settembre 2026",
      sections: [
        { h: "Titolare del trattamento", p: "Il titolare del trattamento dei dati è VPS Group S.r.l., contattabile all'indirizzo email info@vpsgroupsrl.com." },
        { h: "Dati raccolti", p: "Tramite il modulo contatti raccogliamo: nome, azienda, email aziendale e dati tecnici preliminari (consumo energetico, temperatura di processo) forniti volontariamente dall'utente." },
        { h: "Finalità del trattamento", p: "I dati sono utilizzati esclusivamente per rispondere alle richieste di simulazione energetica, inviare la documentazione tecnica richiesta e gestire il contatto commerciale." },
        { h: "Base giuridica e conservazione", p: "Il trattamento si basa sul consenso dell'interessato e sul legittimo interesse. I dati sono conservati per il tempo necessario a gestire la richiesta e comunque non oltre 24 mesi." },
        { h: "Diritti dell'interessato", p: "Ai sensi del GDPR (Reg. UE 2016/679) puoi richiedere accesso, rettifica, cancellazione e limitazione del trattamento scrivendo a info@vpsgroupsrl.com." },
        { h: "Cookie", p: "Il sito utilizza cookie tecnici necessari al funzionamento e cookie analitici, attivati solo previa accettazione tramite il banner dedicato." },
      ],
    },
    en: {
      title: "Privacy Policy",
      updated: "Last updated: September 2026",
      sections: [
        { h: "Data controller", p: "The data controller is VPS Group S.r.l., reachable at info@vpsgroupsrl.com." },
        { h: "Data collected", p: "Through the contact form we collect: name, company, business email and preliminary technical data (energy consumption, process temperature) voluntarily provided by the user." },
        { h: "Purpose of processing", p: "Data is used exclusively to respond to energy simulation requests, send the requested technical documentation and manage the business contact." },
        { h: "Legal basis and retention", p: "Processing is based on the data subject's consent and legitimate interest. Data is retained for the time needed to handle the request and in any case no longer than 24 months." },
        { h: "Your rights", p: "Under the GDPR (EU Regulation 2016/679) you may request access, rectification, erasure and restriction of processing by writing to info@vpsgroupsrl.com." },
        { h: "Cookies", p: "The site uses technical cookies required for operation and analytics cookies, activated only after acceptance via the dedicated banner." },
      ],
    },
  },
  termini: {
    it: {
      title: "Termini e Condizioni",
      updated: "Ultimo aggiornamento: settembre 2026",
      sections: [
        { h: "Oggetto", p: "Questo sito presenta i prodotti e le tecnologie di VPS Group S.r.l., in particolare il sistema di concentrazione solare Diamond Sky." },
        { h: "Proprietà intellettuale", p: "Contenuti, marchi, logo, immagini e dati tecnici sono di proprietà di VPS Group S.r.l. e non possono essere riprodotti senza autorizzazione scritta." },
        { h: "Dati tecnici", p: "I dati tecnici e finanziari pubblicati hanno valore illustrativo. I valori certificati sono riportati nella relazione tecnica ENEA scaricabile dal sito; le condizioni effettive sono definite in sede contrattuale." },
        { h: "Limitazione di responsabilità", p: "VPS Group non risponde di danni derivanti dall'uso delle informazioni pubblicate, che non costituiscono offerta vincolante." },
        { h: "Legge applicabile", p: "I presenti termini sono regolati dalla legge italiana. Per ogni controversia è competente il foro del titolare." },
      ],
    },
    en: {
      title: "Terms & Conditions",
      updated: "Last updated: September 2026",
      sections: [
        { h: "Purpose", p: "This website presents the products and technologies of VPS Group S.r.l., in particular the Diamond Sky concentrated solar system." },
        { h: "Intellectual property", p: "Content, trademarks, logo, images and technical data are the property of VPS Group S.r.l. and may not be reproduced without written authorization." },
        { h: "Technical data", p: "Published technical and financial data are for illustrative purposes. Certified values are reported in the ENEA technical report downloadable from the site; actual conditions are defined contractually." },
        { h: "Limitation of liability", p: "VPS Group is not liable for damages arising from the use of published information, which does not constitute a binding offer." },
        { h: "Governing law", p: "These terms are governed by Italian law. The owner's court has jurisdiction over any dispute." },
      ],
    },
  },
};

export default function Legal({ type }) {
  const { lang } = useLang();
  const doc = content[type][lang];

  return (
    <div className="min-h-screen px-6 py-24" data-testid={`legal-${type}-page`}>
      <div className="max-w-3xl mx-auto">
        <img src="/assets/logo.png" alt="VPS Group" className="h-10 w-auto mb-10" />
        <h1 className="font-display font-bold text-3xl sm:text-4xl tracking-tight" data-testid="legal-title">{doc.title}</h1>
        <p className="mt-2 text-xs text-steel/60">{doc.updated}</p>
        <div className="mt-10 space-y-8">
          {doc.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display font-semibold text-lg text-volt">{s.h}</h2>
              <p className="mt-2 text-sm text-steel leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
        <Link to="/" className="btn-outline mt-12" data-testid="legal-back-button"><ArrowLeft size={16} /> Home</Link>
      </div>
    </div>
  );
}
